import { Avatar } from '@mui/material';
import { chatPhotoUrl } from '../../../../utils/constants/links';
import { WD } from '../../../warningDashboard/warningTheme';

/** A person's portal photo, or their initial. */
export default function PersonAvatar({ person, size = 36 }) {
  return (
    <Avatar
      src={person?.photo ? `${chatPhotoUrl}/${person.photo}.jpg` : undefined}
      alt={person?.name || ''}
      sx={{ width: size, height: size, fontSize: size * 0.4, fontWeight: 700, bgcolor: WD.greenTint, color: WD.green }}
    >
      {String(person?.name || '?').trim().charAt(0).toUpperCase()}
    </Avatar>
  );
}
